import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.update-qs-checks-mandant-options';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksUpdateQsChecksMandantOptionsEffects {

    UpdateQsChecksMandantOptions$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_UPDATE_QS_CHECKS_MANDANT_OPTIONS),
        mergeMap((x: ac.PostUpdateQsChecksMandantOptionsAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postUpdateQsChecksMandantOptions(x.qsChecksMandantOptions).pipe(
                map((result: any) => {
                    return new ac.PostUpdateQsChecksMandantOptionsErfolgreichAction(x.qsChecksMandantOptions, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostUpdateQsChecksMandantOptionsFehlerAction(error, x.qsChecksMandantOptions, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.QsChecksCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.QsChecksCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.QsChecksCommandService);
        }
        return this.service;
    }
}
